import { useNavigate } from 'react-router-dom'
import { motion, useReducedMotion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { useLanguage } from '../../contexts/LanguageContext'
import { Button } from '../ui/button'
import { Magnetic, burstFromEvent } from '../celebration'

// Closing CTA: deep-ink bubble panel with drifting candy blobs, a magnetic
// hot-gradient action and a confetti burst on click.
const FinalCta = () => {
  const { language } = useLanguage()
  const navigate = useNavigate()
  const isKa = language === 'ka'
  const reduce = useReducedMotion()

  return (
    <section className="px-5 pb-16 pt-4 lg:pb-24">
      <motion.div
        initial={reduce ? false : { opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="relative mx-auto max-w-6xl overflow-hidden rounded-bubble-lg bg-celebration-ink px-6 py-16 text-center shadow-[0_30px_60px_rgba(27,16,51,0.35)] dark:bg-[#1e1438] lg:py-20"
      >
        {/* Candy blobs glowing through the dark panel */}
        <div
          aria-hidden="true"
          className="blob blob-pink blob-drift"
          style={{ width: 420, height: 420, top: -160, left: -120, opacity: 0.4 }}
        />
        <div
          aria-hidden="true"
          className="blob blob-sky blob-drift-slow"
          style={{ width: 380, height: 380, bottom: -160, right: -100, opacity: 0.35 }}
        />
        <div
          aria-hidden="true"
          className="blob blob-violet"
          style={{ width: 320, height: 320, bottom: -180, left: '38%', opacity: 0.3 }}
        />
        <div className="relative">
          <h2 className="mx-auto max-w-[20ch] font-lynx text-balance text-[clamp(2rem,4.5vw,3.2rem)] font-semibold leading-[1.05] tracking-tight text-white">
            {isKa ? 'შენი ღონისძიება იწყება აქედან' : 'Your event starts here'}
          </h2>
          <p className="mx-auto mt-4 max-w-[48ch] text-lg text-white/80">
            {isKa ? 'შექმენი შენი პირველი მოსაწვევი' : 'Create your first invitation'}
          </p>
          <Magnetic className="mt-8 inline-block">
            <Button
              onClick={(e) => {
                burstFromEvent(e)
                navigate('/login')
              }}
              className="group h-12 rounded-full btn-gradient px-7 text-[15px] font-semibold text-white"
              data-testid="home-cta-bottom"
            >
              {isKa ? 'დაიწყე' : 'Get started'}
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </Button>
          </Magnetic>
        </div>
      </motion.div>
    </section>
  )
}

export default FinalCta
